/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import { PageView, Event } from "../GoogleAnalytics";
import DataFromDatePicker from '../DataFromDatePicker/DataFromDatePicker';
import InstallCheck from "../Devices/InstallationCheck";
import InstallService from "../../services/install.service";
import AlertService from "../../services/alerts.service";
import LongArrowUpIcon from '@mui/icons-material/ArrowUpward';
import LongArrowDownIcon from '@mui/icons-material/ArrowDownward';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import moment from "moment/moment";

import {roles, alertCustomer, MONTHS} from "../../componentObjects";
import { withRouter } from '../Routing/withRouter';
import Loader from "../Loader/Loader";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import HistoricalInstallCheck from "../Devices/HistoricalInstallCheck/HistoricalInstallCheck";
const animatedComponents = makeAnimated();

let TECH_OPTIONS = [
    {
        value: -1,
        label: 'All'
    }
];

const currentDate = new Date();
const RADIO_NEW = "NewInstalls";
const RADIO_REPAIRS = "Repairs";
const RADIO_INPROGRESS = "InProgress";
const csvBaseName = "InstallReport";

class InstallReport extends Component {
    static displayName = "Install Report";
    static defaultSortCol = "DATE";
    _isMounted = false;

    constructor(props) {
        super(props);

        this.populateData = this.populateData.bind(this);
        this.changeTableRadio = this.changeTableRadio.bind(this);
        this.onColumnClick = this.onColumnClick.bind(this);
        this.columnSort = this.columnSort.bind(this);
        this.onInstallClick = this.onInstallClick.bind(this);
        this.cacheInstallCheck = this.cacheInstallCheck.bind(this);
        this.clearAvgCurrentListObject = this.clearAvgCurrentListObject.bind(this);
        this.openDownloadModal = this.openDownloadModal.bind(this);
        this.showDownloadModal = this.showDownloadModal.bind(this);
        this.onDownloadClick = this.onDownloadClick.bind(this);
        this.onChangeTechnicianFilter = this.onChangeTechnicianFilter.bind(this);

        this.state = {
            loading: false,
            installLoading: false,
            customerLoading: false,
            currentRadio: "NewInstalls",
            monthlyInstallsObj: {},
            installsList: [],
            repairsList: [],
            inProgressList: [],
            tableList: [],
            downloadData: [],
            technicianList: [],
            technicianOptions: TECH_OPTIONS,
            techFilter: TECH_OPTIONS[0],

            columnSort: {
                enabled: true,
                type: this.defaultSortCol,
                reverse: false
            },

            dateSelected: currentDate,
            selected: 0,
            selectedDeviceName: "",
            currentCustomer: alertCustomer,
            currentPartnerName: "",
            cachedResults: {},
            showDownloadConfirm: false
        }
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        this.baseUrl = window.location.href;
        
        if (this.baseUrl.toLowerCase().indexOf("repairs") >= 0) {
            this.setState({
                currentRadio: RADIO_REPAIRS
            }, () => this.populateData(this.state.dateSelected));
        }
        else if (this.baseUrl.toLowerCase().indexOf("inprogress") >= 0 ||
            (this.props.location !== undefined && 
            this.props.location !== null && 
            this.props.location.state !== undefined && 
            this.props.location.state !== null && 
            this.props.location.state.currentRadio === "InProgress")) {
            this.setState({
                currentRadio: "InProgress"
            }, () => this.populateData(this.state.dateSelected));
        }
        else {
            this.populateData(this.state.dateSelected);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentPartnerId !== this.props.currentPartnerId) {
            this.populateData(this.state.dateSelected);
        }
    }

    changeTableRadio(e) {
        let x = e.target.value;

        this.setState({
            currentRadio: x,
            selected: -1,
            columnAltered: false,
            columnSort: {
                enabled: false,
                type: null,
                reverse: false
            },
            tableList: x === "NewInstalls" ? this.state.installsList : x === "Repairs" ? this.state.repairsList : this.state.inProgressList
        }, () => {
            let techOptions = this.getTechnicianOptions(this.state.tableList);
            this.setState({ technicianOptions: techOptions });
        });
    }
    
    onChangeTechnicianFilter = (selectedOption) => {
        let x = selectedOption;
        let techList = x === TECH_OPTIONS[0] ? [] : this.state.tableList.filter(t => t.technicianId === selectedOption.value);
        this.setState({
            techFilter: x,
            techList: techList
        });
    }

    populateData(date) {
        this.setState({ loading: true, selected: -1, selectedDeviceName: "" }, () => {
            const partnerId = this.props.currentPartnerId;

            if (!partnerId) {
                this.setState({
                    monthlyInstallsObj: {},
                    installsList: [],
                    repairsList: [],
                    inProgressList: [],
                    tableList: [],
                    loading: false,
                    technicianOptions: TECH_OPTIONS
                });
                return;
            }

            const yearSelected = date.getFullYear();
            const monthSelected = date.getMonth() + 1;

            InstallService.getmonthlypartnerinstalls(monthSelected, yearSelected, partnerId)
                .then(response => {
                    if (!this._isMounted) {
                        this.setState({
                            monthlyInstallsObj: {},
                            installsList: [],
                            repairsList: [],
                            inProgressList: [],
                            tableList: [],
                            loading: false,
                            technicianOptions: TECH_OPTIONS
                        });
                        return;
                    }
                    const allInstalls = response.data;
                    const installsList = allInstalls.filter(i => i.installTypeId === 1);
                    const repairsList = allInstalls.filter(i => i.installTypeId !== 1);
                    const inProgressList = allInstalls.filter(i => i.installStatusId === 1);

                    this.setState({
                        monthlyInstallsObj: response.data,
                        installsList,
                        repairsList,
                        inProgressList,
                        tableList: this.state.currentRadio === "NewInstalls" ? installsList
                            : this.state.currentRadio === "Repairs" ? repairsList
                            : inProgressList,
                        loading: false
                    }, () => {
                        const techOptions = this.getTechnicianOptions(this.state.tableList);
                        this.setState({ technicianOptions: techOptions });
                    });
                })
                .catch(e => {
                    console.log(e);
                    if (this._isMounted) {
                        this.setState({
                            monthlyInstallsObj: {},
                            installsList: [],
                            repairsList: [],
                            inProgressList: [],
                            tableList: [],
                            loading: false,
                            technicianOptions: TECH_OPTIONS
                        });
                    }
                });
        });
    }

    onColumnClick(selectedCol) {
        this.setState({ selected: -1, currentCustomer: alertCustomer, currentPartnerName: "", customerLoading: false }, () => {
            const colSort = this.state.columnSort;
            let newSort = colSort;
            let data = this.state.monthlyInstallsObj;
            let colData = [];
            let colAltered = false;

            if (colSort.enabled) {
                if (colSort.type == selectedCol) {
                    if (colSort.reverse) {
                        newSort = {
                            enabled: false,
                            type: null,
                            reverse: false
                        };
                        colData = this.columnSort(data, "DATE", false); /* default sort by is start time */
                        colAltered = false;
                    }
                    else {
                        newSort.reverse = true;
                        colData = this.columnSort(data, selectedCol, true);
                        colAltered = true;
                    }
                }
                else {
                    newSort = {
                        enabled: true,
                        type: selectedCol,
                        reverse: false
                    };
                    colData = this.columnSort(data, selectedCol, false);
                    colAltered = true;
                }
            }
            else {
                newSort = {
                    enabled: true,
                    type: selectedCol,
                    reverse: false
                };
                colData = this.columnSort(data, selectedCol, false);
                colAltered = true;
            }

            this.setState({ columnSort: newSort, tableList: colData }, () => {
                this.setState({ columnAltered: colAltered });
            });
        })
    }

    columnSort(dataList, col, isReverse) {
        let colData = [];
        let data = dataList;

        if (col === "TECHNICIAN") {
            colData = data.sort((a, b) => {
                const nameA = a.technicianName || '';
                const nameB = b.technicianName || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "DEVICE") {
            colData = data.sort((a, b) => {
                const nameA = a.macId || '';
                const nameB = b.macId || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "CUSTOMER_NAME") {
            colData = data.sort((a, b) => {
                const nameA = a.customerName || '';
                const nameB = b.customerName || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "GATEWAY_TYPE") {
            colData = data.sort((a, b) => {
                const nameA = a.gatewayType || '';
                const nameB = b.gatewayType || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "INSTALL_TYPE") {
            colData = data.sort((a, b) => {
                const nameA = a.installType || '';
                const nameB = b.installType || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "INSTALL_STATUS") {
            colData = data.sort((a, b) => {
                const nameA = a.installStatus || '';
                const nameB = b.installStatus || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "BILLING_PLAN") {
            colData = data.sort((a, b) => {
                const nameA = a.billingPlan || '';
                const nameB = b.billingPlan || '';

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "DATE") {
            colData = data.sort((a, b) => {
                const dateA = new Date(a.startDateTime);
                const dateB = new Date(b.startDateTime);
                return dateB - dateA;
            });
        }
        else if (col === "TOTAL_TIME") {
            colData = data.sort((a, b) => {
                const nameA = a.totalTime || '';
                const nameB = b.totalTime || '';

                return nameA.localeCompare(nameB);
            });
        }

        if (isReverse) {
            colData = colData.reverse();
        }

        return colData;
    }

    clearAvgCurrentListObject() {
        return {
            avgMainCurrent: [],
            avgInducerCurrent: [],
            avgBlowerCurrent: []
        }
    }

    onInstallClick(index, deviceName) {
        Event("Install Clicked", "User clicked an install in Installs Check", "Installs Check Install Clicked");
        let x = index;
        let install = this.state.tableList?.[x];
        
        if (this.state.selected === x) {
            this.setState({ selected: -1, currentCustomer: alertCustomer, currentPartnerName: "", customerLoading: false });
        } else {
            this.setState({
                selected: x,
                selectedDeviceName: deviceName,
                customerLoading: true
            }, async () => {
                if (install.customerName?.length > 0) {
                    this.setState({
                        currentCustomer: { name: install?.customerName },
                        customerLoading: false
                    });
                } else {
                    await AlertService.get(install.customerOrgId)
                        .then(response => {
                            if (this._isMounted)
                                this.setState({
                                    currentCustomer: response.data
                                }, () => {
                                    this.getCustomerPartner(this.state.currentCustomer.parentOrganizationId);
                                });
                        })
                        .catch(e => {
                            console.log(e);
                        });
                }
            });
        }
    }

    getCustomerPartner(id) {
        const x = this.props.partners.find(p => p.organizationId === id);
        let partnerStr = "";

        if (x !== undefined && x != null && x.company !== null) {
            partnerStr = x.company + " (" + x.name + ")";
        }
        else {
            partnerStr = "Name unavailable for PartnerID  " + id; /* todo fetch info? */
        }

        this.setState({ currentPartnerName: partnerStr, customerLoading: false });
    }
    
    getCsvData(list) {
        let data = list.map(item => {
            return {
                technician: item.technicianName,
                macId: item.macId,
                gatewayType: item.gatewayType,
                installType: item.installType,
                installStatus: item.installStatus,
                billingPlan: item.billingPlan,
                date: moment.utc(item.startDateTime).local().format("MM/DD/YYYY hh:mm a"),
                totalTime: item.totalTime
            }
        });
        const array = [Object.keys(data[0])].concat(data.map(obj => Object.values(obj)));
        return array.map(row => row.join(',')).join('\n');
    }

    onDownloadClick() {
        let filenameWithDate = MONTHS[this.state.dateSelected.getMonth()] + "_" + csvBaseName;
        const fileData = this.getCsvData(this.state.tableList);
        const csvContent = "data:text/csv;charset=utf-8," + encodeURIComponent(fileData);
        const link = document.createElement("a");
        link.setAttribute("href", csvContent); // Set csvContent directly
        link.setAttribute("download", filenameWithDate || "data.csv");
        document.body.appendChild(link);
        link.click();
    }

    openDownloadModal() {
        this.setState({
            modalTitle: 'Download Report',
            modalMessage: 'You are about to download the table data into a .csv file. Continue?'
        }, () => {
            this.showDownloadModal();
        });
    }

    showDownloadModal() {
        this.setState({ showDownloadConfirm: !this.state.showDownloadConfirm });
    }

    iconFunction(columnName, columnSort) {
        let arrowIcon = columnSort.enabled ?
            (columnSort.reverse ?
                <LongArrowDownIcon style={{ height: '16px', width: '15px', paddingBottom: '2px' }} />
                : <LongArrowUpIcon style={{ height: '16px', width: '15px', paddingBottom: '2px' }} />)
            : null;

        let icon = columnSort.enabled && columnSort.type === columnName ?
            <span style={{ height: '15px', paddingLeft: '3px' }}>
                {arrowIcon}
            </span>
            : null;

        return icon;
    }

    renderDatePicker() {

        const handleChange = async date => {
            this.setState({ dateSelected: date, loading: true });
            await this.populateData(date);
        };

        return (
            <DataFromDatePicker dateSelected={this.state.dateSelected} handleChange={handleChange} />
        );
    }

    getExpandContent(index, deviceName) {
        let install = this.state.tableList?.[index];
        let customerInfo = <p style={{marginBottom: '10px'}}><span className='semibold'>Customer:</span> &nbsp; {this.state.customerLoading ?
            <div className="dot-flashing margin-left-25 margin-top-10 margin-bottom-10"></div> : install.customerName}</p>
        
        return (
            <tr className="no-hover expanded" key={`expandedContent-${index}`} style={{backgroundColor: 'white !important'}}>
                <td colSpan={this.state.currentRadio === "NewInstalls" ? 11 : 12} style={{color: 'unset'}}>
                    {customerInfo}
                    <HistoricalInstallCheck installId={install.id} requestPayload={install.requestPayload} registeredDevices={install.registeredDevices} roles={this.props.roles} macId={install.macId} />
                </td>
            </tr>
        );
    }
    
    cacheInstallCheck(installCheckObject) {
        installCheckObject.customerName = this.state.currentCustomer?.name?.trim();
        
        this.setState((prevState) => ({
            cachedResults: {
                ...prevState.cachedResults,
                [installCheckObject.macId]: installCheckObject
            },
        }));
    }

    getReplaced(currentRadio, item) {
        if (currentRadio === "NewInstalls") {
            return (null);
        }
        else {
            return (
                <td>{item.replacedMacId}</td>
            )
        }
    }
    
    getTechnicianOptions = (summaryData) => {
        let options = TECH_OPTIONS;
        let dataByTechId = [...new Map(summaryData.map(item => [item.technicianId, item])).values()];
        dataByTechId.forEach((item) => {
            let techOption = {
                value: item.technicianId,
                label: item.technicianName
            };
            options.push(techOption);
        });
        return options;
    }

    renderTable() {
        let summaryData = this.state.techFilter === TECH_OPTIONS[0] ? this.state.tableList : this.state.techList;//this.state.monthlyInstallsObj;

        let summaryContent = summaryData.length ?
            <tbody>
            {summaryData.map((item, index) =>
                [<tr
                    className={this.state.selected == index ? "alerts-table-selected alerts-table-row" : "alerts-table-row"}
                    key={item.id} data={index} value={index}
                    onClick={() => this.onInstallClick(index, item.macId)}>
                    <td style={{padding: '16px 0px 16px 10px', borderLeft: '1px solid #ebeef0'}}>
                        {item.technicianName}
                    </td>
                    <td>{item.macId}</td>
                    {this.getReplaced(this.state.currentRadio, item)}
                    <td>{item.customerName}</td>
                    <td>{item.gatewayType}</td>
                        <td>{item.installType}</td>
                        <td>{item.installStatus}</td>
                        <td>{item.billingPlan}</td>
                        <td>{moment.utc(item.startDateTime).local().format("MM/DD/YYYY hh:mm a")}</td>
                        <td>{item.totalTime}</td>
                        <td className="alerts-td-right">
                            {this.state.selected == index ?
                                <ArrowUpIcon className="db-blue-reverse" style={{borderRadius: '12px'}}/> :
                                <ArrowDownIcon className="db-blue db-blue-bg" style={{borderRadius: '12px'}}/>}
                        </td>
                    </tr>,
                        this.state.selected == index && (this.getExpandContent(index, item.macId))
                    ])}
            </tbody>
            : <tbody>
                <tr>
                    <td>{""}</td>
                </tr>
            </tbody>;


        let replaceHeader = this.state.currentRadio === "NewInstalls" ?
            null
            : <th>
                <div onClick={() => this.onColumnClick("REPLACE")}>
                    <span style={{ cursor: 'pointer' }}>REPLACED ID</span>
                    {this.iconFunction("REPLACE", this.state.columnSort)}
                </div>
            </th>;

        return (
            <div style={{ margin: '20px 30px' }}>

                <div>
                    <table className="table-hover" style={{ width: '100%' }}>

                        <thead>
                        <tr className="alerts-table-row">
                            <th style={{padding: '0px 0px 0px 10px'}}>
                                <div onClick={() => this.onColumnClick("TECHNICIAN")}>
                                    <span style={{cursor: 'pointer'}}>TECHNICIAN</span>
                                    {this.iconFunction("TECHNICIAN", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("DEVICE")}>
                                    <span style={{cursor: 'pointer'}}>MAC ID</span>
                                    {this.iconFunction("DEVICE", this.state.columnSort)}
                                </div>
                            </th>
                            {replaceHeader}
                            <th>
                                <div onClick={() => this.onColumnClick("CUSTOMER_NAME")}>
                                    <span style={{cursor: 'pointer'}}>CUSTOMER NAME</span>
                                    {this.iconFunction("CUSTOMER_NAME", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("GATEWAY_TYPE")}>
                                    <span style={{cursor: 'pointer'}}>GATEWAY TYPE</span>
                                    {this.iconFunction("GATEWAY_TYPE", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("INSTALL_TYPE")}>
                                    <span style={{cursor: 'pointer'}}>INSTALL TYPE</span>
                                    {this.iconFunction("INSTALL_TYPE", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("INSTALL_STATUS")}>
                                    <span style={{cursor: 'pointer'}}>INSTALL STATUS</span>
                                    {this.iconFunction("INSTALL_STATUS", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("BILLING_PLAN")}>
                                    <span style={{cursor: 'pointer'}}>BILLING PLAN</span>
                                    {this.iconFunction("BILLING_PLAN", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("DATE")}>
                                    <span style={{cursor: 'pointer'}}>DATE</span>
                                    {this.iconFunction("DATE", this.state.columnSort)}
                                </div>
                            </th>
                            <th>
                                <div onClick={() => this.onColumnClick("TOTAL_TIME")}>
                                    <span style={{cursor: 'pointer'}}>TOTAL TIME</span>
                                    {this.iconFunction("TOTAL_TIME", this.state.columnSort)}
                                </div>
                            </th>
                            <th className="table-shrink"
                                style={{textAlign: 'center', padding: '10px 10px 10px 5px'}}></th>
                        </tr>
                        </thead>
                        {summaryContent}
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        var isPartnerAdmin = this.props.roles.includes(roles.partnerAdmin);

        let tableContents = this.state.loading ?
            <Loader />
            : this.renderTable();

        let datePicker = this.renderDatePicker();

        let tableOptions = <div className="alerts-tab-wrapper" style={{ margin: '20px 30px 0px', backgroundColor: "#f7f9fa", padding: '10px 0' }}>
            <div className="alerts-tab-label" style={{ paddingLeft: '45px' }}>Table Options</div>
            <div style={{ paddingLeft: '40px', margin: '5px' }}>
                <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                    <div>
                        <input type="radio" value="NewInstalls" checked={this.state.currentRadio === 'NewInstalls'} name="installTableType" onChange={e => this.changeTableRadio(e)} />
                            &nbsp; New Installs &nbsp;&nbsp;
                        <input type="radio" value="Repairs" checked={this.state.currentRadio === 'Repairs'} name="installTableType" onChange={e => this.changeTableRadio(e)} />
                            &nbsp; Repairs &nbsp;&nbsp;
                        <input type="radio" value="InProgress" checked={this.state.currentRadio === 'InProgress'} name="installTableType" onChange={e => this.changeTableRadio(e)} />
                            &nbsp; In Progress &nbsp;&nbsp;
                    </div>
                    <span className={"margin-left-15 alerts-tab-select"} >
                                    <Select
                                        closeMenuOnSelect={true}
                                        components={animatedComponents}
                                        options={this.state.technicianOptions}
                                        onChange={this.onChangeTechnicianFilter}
                                        defaultValue={this.state.techFilter}
                                        value={this.state.techFilter}
                                    />
                    </span>
                    <div style={{ display: "flex" }}>
                        {datePicker}
                    </div>
                    <div style={{ display: "flex" }}>
                        {/*<button className="secondary-btn btn-small" onClick={this.prevPage} disabled={this.state.pageNum == 1 ? true : false} style={{ minWidth: '50px', height: '38px', borderRadius: '.25rem', padding: '0px 10px', marginLeft: '12px' }}>Prev Page</button>
                        <p style={{ padding: '0px 10px', marginTop: "7px", marginBottom: "7px" }}>
                            Page {this.state.pageNum} of {pages}
                        </p>
                        <button className="secondary-btn btn-small" onClick={this.nextPage} disabled={this.state.pageNum == pages ? true : false} style={{ minWidth: '50px', height: '38px', borderRadius: '.25rem', padding: '0px 10px', marginLeft: '12px' }}>Next Page</button>*/}
                    </div>
                </div>
            </div >
        </div >;

        return (

            <div>
                <div >
                    <div className='infoPage'>
                        <div className='row no-gutters'>
                            <div className={"col"}>
                                <h2 className="pageTitle dashboard-title" id="tabelLabel">
                                    Install Report
                                </h2>
                            </div>
                            <div className="col flex-end">
                                <button className="primary-btn btn-large width-250 margin-right-30" onClick={this.onDownloadClick}>Download Reports</button>
                            </div>
                        </div>
                        
                        {tableOptions}
                        { tableContents }
                    </div>
                    <ConfirmationModal show={this.state.showDownloadConfirm} onYes={this.onDownloadClick} onClick={this.showDownloadModal} modalTitle={"Download Instal Report"} modalMessage={"You are about to download the table data as a .csv file. Continue?"} />
                </div>
            </div>

        );
    }
}

export default withRouter(InstallReport);
